import { render, staticRenderFns } from "./delivery-detail.vue?vue&type=template&id=d141d5ca&scoped=true&"
import script from "./delivery-detail.vue?vue&type=script&lang=js&"
export * from "./delivery-detail.vue?vue&type=script&lang=js&"
import style0 from "./delivery-detail.vue?vue&type=style&index=0&id=d141d5ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d141d5ca",
  null
  
)

export default component.exports